export default "__VITE_ASSET__Sie2DsEI__"